import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserMessage } from '@sendbird/chat/message';

@Component({
  standalone: true,
  selector: 'app-reply-preview',
  templateUrl: './reply-preview.component.html',
  styleUrls: ['./reply-preview.component.scss'],
})
export class ReplyPreviewComponent {
  @Input() parentMessage!: UserMessage | null;
  @Output() cancelReplyPreview = new EventEmitter<void>();

  cancel() {
    this.cancelReplyPreview.emit();
  }
}
